__turbopack_context__.v({
  "bar": "ImpromptuMicIndicator-module__TLS81a__bar",
});
